import type { FC } from 'react';

interface DotsIconProps {
  variant?: 'horizontal' | 'vertical';
  className?: string;
}

export const DotsIcon: FC<DotsIconProps> = ({ variant = 'horizontal', className }) => {
  if (variant === 'horizontal') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 13 3"
        fill="none"
        className={className}
      >
        <circle cx="1.5" cy="1.5" r="1.5" transform="rotate(-90 1.5 1.5)" fill="currentColor" />
        <circle cx="6.5" cy="1.5" r="1.5" transform="rotate(-90 6.5 1.5)" fill="currentColor" />
        <circle cx="11.5" cy="1.5" r="1.5" transform="rotate(-90 11.5 1.5)" fill="currentColor" />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 3 14"
      fill="none"
      className={className}
    >
      <ellipse cx="1.5989" cy="2" rx="1.4011" ry="1.5" fill="currentColor" />
      <ellipse cx="1.5989" cy="7" rx="1.4011" ry="1.5" fill="currentColor" />
      <ellipse cx="1.5989" cy="12" rx="1.4011" ry="1.5" fill="currentColor" />
    </svg>
  );
};
